import React, { Component } from "react";
import { connect } from "react-redux";
import {
	numberWithCommas,
	makeDebouncedFunction,
} from "../../utilities/utilities";
import { IconAlertTriangle } from "@tabler/icons-react";
import { LabeledTextInput } from "../TextInput";
import { Loader } from "@mantine/core";
import { shouldShowDeveloperMessages } from "../../reducers/developerOverridesReducer";
import { showAsDeveloperMessage } from "../Developer/showAsDeveloperMessage";
import { getCascadeDeleteDescription } from "./trashBinUtils";

class PermanentDeleteConfirmationModalUnconnected extends Component {
	constructor(props) {
		super(props);
		this.state = {
			loading: true,
			confirmTextBox: "",
		};
		this.handleChangeHere = makeDebouncedFunction(
			this.handleChangeHere.bind(this),
			300
		);
	}

	handleChangeHere(key, value) {
		const changeCallback = () => {
			// send the changes back to the parent component (in this case EditDialog)
			// expects each one to be a separate call
			// so I moved all info into a single object
			this.props.onChange("permanentDeleteConfirmationObject", {
				confirmed:
					this.state.confirmTextBox &&
					this.state.confirmTextBox.toLowerCase() === "confirm",
			});
		};
		this.setState({ [key]: value }, changeCallback);
	}

	componentDidMount() {
		const { objectTypeCount, totalObjectsInManifest } = this.props;

		const keyMap = {
			document: "Document",
			folder: "Folder",
			email: "Email",
			note: "Note",
			matter: "Matter",
			client: "Client",
		};

		let rootFoldersWillBeDeleted = false;
		let newTotalObjectsInManifest = totalObjectsInManifest;
		let numberOfRootFolders = 0;

		if (objectTypeCount.matter) {
			// we need to reduce the folder count because we do not want to count the "docs", "email" or "notes" root folders in the count
			let numberOfRootFoldersPerMatter = 3; // docs, email, notes
			numberOfRootFolders =
				objectTypeCount.matter * numberOfRootFoldersPerMatter;
			newTotalObjectsInManifest -= numberOfRootFolders;
			rootFoldersWillBeDeleted = true;
			if (objectTypeCount.folder) {
				// if there are folders, we need to reduce the folder count by the number of matter folders
				objectTypeCount.folder -= numberOfRootFolders;
			}
			if (objectTypeCount.folder <= 0) {
				delete objectTypeCount.folder;
			}
		}

		this.setState({
			rootFoldersWillBeDeleted,
			newTotalObjectsInManifest,
			numberOfRootFolders,
			objectTypeCount,
			keyMap,
			loading: false,
		});
	}

	render() {
		const {
			rootFoldersWillBeDeleted,
			newTotalObjectsInManifest,
			numberOfRootFolders,
			objectTypeCount,
			keyMap,
		} = this.state;

		// this loading prop is in the permanentDeleteConfirmationObject that is passed into openGlobalDialog
		if (this.props.loading || this.state.loading) {
			return <Loader />;
		}

		const { cascadeDeleteDescription, shouldShowCascadeDeleteDescription } =
			getCascadeDeleteDescription({
				trashPageContextWithUnknownTrailingSlash:
					this.props.trashPageContext,
				objectTypeCount,
			});

		return (
			<div>
				<div
					style={{
						borderRadius: 5,
						backgroundColor: "var(--lw-darker-red)",
						display: "flex",
						alignItems: "center",
						color: "white",
						marginBottom: 16,
					}}
				>
					<IconAlertTriangle
						style={{
							color: "white",
							margin: 10,
						}}
					/>{" "}
					{`Warning: This action cannot be undone!`}
				</div>

				{shouldShowCascadeDeleteDescription ? (
					<div style={{ marginBottom: 16 }}>
						{cascadeDeleteDescription}
					</div>
				) : null}

				<div style={{ marginBottom: 8 }}>
					If confirmed, the following items will be permanently
					deleted:
				</div>
				<div style={{ marginBottom: 16 }}>
					<ul>
						{Object.entries(objectTypeCount).map(([key, value]) => {
							return (
								<li key={key}>
									{`${numberWithCommas(value)} ${keyMap[key]}${
										value > 1 ? "s" : ""
									}`}
								</li>
							);
						})}
					</ul>
					{rootFoldersWillBeDeleted &&
					this.props.showDeveloperMessages
						? showAsDeveloperMessage(
								`The folder count does not include the root folders for each matter (docs, email, notes). There are ${numberWithCommas(
									numberOfRootFolders
								)} root folders in this permanent delete manifest.`
							)
						: null}
				</div>
				<div>
					<div style={{ marginBottom: 16 }}>
						{`Are you sure you want to continue? This will permanently delete ${numberWithCommas(newTotalObjectsInManifest)} item${newTotalObjectsInManifest > 1 ? "s" : ""}. Please type "confirm" in the box below to confirm and proceed.`}
					</div>
					<LabeledTextInput
						label=""
						name="confirmTextBox"
						defaultValue={this.state.confirmTextBox}
						placeholder="Type confirm here"
						onChange={this.handleChangeHere}
						autocomplete="off"
					/>
				</div>
			</div>
		);
	}
}

const mapStateToProps = (state) => {
	let showDeveloperMessages = shouldShowDeveloperMessages(
		state.developerOverrides.showDeveloperMessages
	);

	return {
		showDeveloperMessages,
	};
};

const PermanentDeleteConfirmationModal = connect(mapStateToProps)(
	PermanentDeleteConfirmationModalUnconnected
);

export default PermanentDeleteConfirmationModal;
